import { useState } from 'react';
import Button from 'epn-ui/umd/dist/components/Button';

// Helpers
import useI18n from '@i18n';

// Components
import UploadFiles from '@components/pages/support/UploadFiles';

// Config
import { MODAL_UPLOAD_FILES_CONTAINER } from '../../../config';

export interface ICreateMessageActionsProps {
    loading: boolean;
    onClose: () => void;
}

const TemplateActions: React.FC<ICreateMessageActionsProps> = ({ loading, onClose }) => {
    const [uploadIsProgress, setUploadIsProgress] = useState<boolean>(false);
    const { t } = useI18n('Support');

    return (
        <>
            <div
                id={MODAL_UPLOAD_FILES_CONTAINER}
                className="flex flex-col flex-wrap mb-4 gap-[16px] xs:flex-row"
            />
            <div className="flex flex-col items-center justify-between xs:flex-row">
                <UploadFiles
                    fileContainerId={MODAL_UPLOAD_FILES_CONTAINER}
                    onProgress={setUploadIsProgress}
                />
                <div className="flex flex-col w-full mt-4 mb-0 gap-4 xs:gap-6 xs:flex-row xs:w-auto">
                    <Button
                        type="primary"
                        htmlType="submit"
                        loading={loading || uploadIsProgress}
                        className="w-full xs:w-auto"
                    >
                        {t('Send message')}
                    </Button>
                    <Button onClick={() => onClose()} className="w-full xs:w-auto min-w-min">
                        {t('Close')}
                    </Button>
                </div>
            </div>
        </>
    );
};

export default TemplateActions;
